var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5386 49.304C30.7436 50.2051 29.3391 50.2066 28.5421 49.3073L12.2019 30.8694C11.5198 30.0998 11.5325 28.9383 12.2314 28.1839L28.5329 10.5842C29.3244 9.72957 30.6759 9.72958 31.4675 10.5842L47.7714 28.1868C48.4691 28.9401 48.4831 30.0992 47.8038 30.8691L31.5386 49.304Z",
    fill: "url(#paint0_linear_2944_4781)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.4995,
    y: 16.0059,
    width: 3,
    height: 15.472,
    rx: 1.5,
    transform: "rotate(43.038 27.4995 16.0059)",
    fill: "white",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2944_4781",
    x1: 49,
    y1: 51,
    x2: 10.2766,
    y2: 9.67794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66E86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRare);
export default __webpack_public_path__ + "static/media/rare.c7d15266988ff9a27fdc0a2e87867b5b.svg";
export { ForwardRef as ReactComponent };